import styles from "./Ad.module.scss"

import React from "react"
import { useParams } from "react-router-dom"

import { WOWNET_CONTENT } from "@shared/constants"

export default function Ad() {
  const { streamerName } = useParams<{ streamerName?: string }>()

  return (
    <div className="iframeB">
      <iframe
        title="하단 광고"
        className={styles.footerSize}
        src={`${WOWNET_CONTENT.footerMini}?analid=${streamerName}`}
      />
    </div>
  )
}
